/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreditAwareSolution } from './CreditAwareSolution';
import {
    CreditAwareSolutionFromJSON,
    CreditAwareSolutionFromJSONTyped,
    CreditAwareSolutionToJSON,
    CreditAwareSolutionToJSONTyped,
} from './CreditAwareSolution';

/**
 * 
 * @export
 * @interface CreditAwareSearchResponse
 */
export interface CreditAwareSearchResponse {
    /**
     * Number of active credits for this user
     * @type {number}
     * @memberof CreditAwareSearchResponse
     */
    userCreditsCount?: number;
    /**
     * Total number of pricing solutions
     * @type {number}
     * @memberof CreditAwareSearchResponse
     */
    totalSolutions?: number;
    /**
     * 
     * @type {Array<CreditAwareSolution>}
     * @memberof CreditAwareSearchResponse
     */
    solutions?: Array<CreditAwareSolution>;
}

/**
 * Check if a given object implements the CreditAwareSearchResponse interface.
 */
export function instanceOfCreditAwareSearchResponse(value: object): value is CreditAwareSearchResponse {
    return true;
}

export function CreditAwareSearchResponseFromJSON(json: any): CreditAwareSearchResponse {
    return CreditAwareSearchResponseFromJSONTyped(json, false);
}

export function CreditAwareSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditAwareSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userCreditsCount': json['user_credits_count'] == null ? undefined : json['user_credits_count'],
        'totalSolutions': json['total_solutions'] == null ? undefined : json['total_solutions'],
        'solutions': json['solutions'] == null ? undefined : ((json['solutions'] as Array<any>).map(CreditAwareSolutionFromJSON)),
    };
}

export function CreditAwareSearchResponseToJSON(json: any): CreditAwareSearchResponse {
    return CreditAwareSearchResponseToJSONTyped(json, false);
}

export function CreditAwareSearchResponseToJSONTyped(value?: CreditAwareSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_credits_count': value['userCreditsCount'],
        'total_solutions': value['totalSolutions'],
        'solutions': value['solutions'] == null ? undefined : ((value['solutions'] as Array<any>).map(CreditAwareSolutionToJSON)),
    };
}

